module.exports = __webpack_public_path__ + "68ea5fa67f31f070b927260f6bfcf471.svg";